import animationBlue from 'img/nestleLanding/animations/photo/blue.riv';
import animationBlueMobile from 'img/nestleLanding/animations/photo/blue_mobile.riv';
import animationGreen from 'img/nestleLanding/animations/photo/green.riv';
import animationGreenMobile from 'img/nestleLanding/animations/photo/green_mobile.riv';
import animationPink from 'img/nestleLanding/animations/photo/pink.riv';
import animationPinkMobile from 'img/nestleLanding/animations/photo/pink_mobile.riv';
import animationRed from 'img/nestleLanding/animations/photo/red.riv';
import animationRedMobile from 'img/nestleLanding/animations/photo/red_mobile.riv';
import bgBlue from 'img/nestleLanding/photo_bg_blue.png';
import bgBlueMobile from 'img/nestleLanding/photo_bg_blue_mobile.png';
import bgGreen from 'img/nestleLanding/photo_bg_green.png';
import bgGreenMobile from 'img/nestleLanding/photo_bg_green_mobile.png';
import bgPink from 'img/nestleLanding/photo_bg_pink.png';
import bgPinkMobile from 'img/nestleLanding/photo_bg_pink_mobile.png';
import bgRed from 'img/nestleLanding/photo_bg_red.png';
import bgRedMobile from 'img/nestleLanding/photo_bg_red_mobile.png';
import { CardColor } from 'reactApp/sections/Nestle/PetsCard/PetsCard.types';

export const animations = {
    [CardColor.blue]: animationBlue,
    [CardColor.green]: animationGreen,
    [CardColor.red]: animationRed,
    [CardColor.pink]: animationPink,
};

export const animationsMobile = {
    [CardColor.blue]: animationBlueMobile,
    [CardColor.green]: animationGreenMobile,
    [CardColor.red]: animationRedMobile,
    [CardColor.pink]: animationPinkMobile,
};

export const backgroundImages = {
    [CardColor.blue]: bgBlue,
    [CardColor.green]: bgGreen,
    [CardColor.red]: bgRed,
    [CardColor.pink]: bgPink,
};

export const backgroundImagesMobile = {
    [CardColor.blue]: bgBlueMobile,
    [CardColor.green]: bgGreenMobile,
    [CardColor.red]: bgRedMobile,
    [CardColor.pink]: bgPinkMobile,
};
